
import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-dark text-white py-20 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-12 flex flex-col items-center lg:items-start">
          <div className="text-4xl font-black tracking-tighter mb-6 select-none">
            <span className="text-medical">Onco</span>
            <span className="text-fhir">FHIR</span>
            <span className="text-white ml-2">Prescribe</span>
          </div>
          <p className="text-gray-400 text-sm max-w-md leading-relaxed font-medium text-center lg:text-left">
            <strong className="text-white">OncoFHIR Prescribe</strong>: Sistema profesional de gestión de terapias oncológicas fundamentado en HL7 FHIR y mCODE implementation guide.
          </p>
        </div>

        {/* Bloque de Disclaimer Legal */}
        <div className="mb-12 p-8 bg-white/5 rounded-3xl border border-white/10">
          <h5 className="text-[10px] font-black uppercase tracking-widest text-fhir mb-4 flex items-center gap-2">
            <i className="fas fa-exclamation-triangle"></i> ⚠️ NOTA IMPORTANTE - DISCLAIMER LEGAL
          </h5>
          <div className="text-[11px] text-gray-400 font-medium leading-relaxed space-y-4 text-justify">
            <p>
              OncoFHIR Prescribe es compatible con protocolos en formato FHIR y se fundamenta en la iniciativa "FHIR-based NCCN chemotherapy orders implementation guide". 
              Los protocolos clínicos específicos de terceros (como NCCN Templates®) requieren licenciamiento directo con sus respectivos proveedores para su uso clínico o comercial.
            </p>
            <p>
              mCODE™ es marca de la mCODE Community bajo estándares de ASCO. NCCN® es marca registrada de National Comprehensive Cancer Network®. 
              HL7® AND FHIR® ARE REGISTERED TRADEMARKS OWNED BY HEALTH LEVEL SEVEN INTERNATIONAL.
            </p>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center text-[10px] font-black text-gray-500 uppercase tracking-widest text-center gap-8 border-t border-white/5 pt-12">
          <p>© 2026 ONCOFHIR PRESCRIBE. TODOS LOS DERECHOS RESERVADOS. AMÉRICA LATINA.</p>
          <div className="flex space-x-8 text-lg">
            <a href="#" className="hover:text-white transition-colors"><i className="fab fa-linkedin"></i></a>
            <a href="#" className="hover:text-white transition-colors"><i className="fab fa-twitter"></i></a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
